import SearchIcon from "@mui/icons-material/Search";
import { Grid2, InputAdornment, Paper, TextField } from "@mui/material";
import React from "react";
import { ShiftDayNavigatorControl } from "../../../../../controls";
import {
	type Section,
	SectionMultiSelect,
} from "../../../../../controls/section-selector";
import { useMesfRealtime } from "../../../../../hooks/useMesfRealtime";

type Props = {
	quickFilter: string;
	onQuickFilterChange: (text: string) => void;
	selectedSections: Section[];
	onSectionsChange: (sections: Section[]) => void;
};

export const Filters = ({
	quickFilter,
	onQuickFilterChange,
	selectedSections,
	onSectionsChange,
}: Props) => {
	useMesfRealtime({
		onReceiveMessage: (author, message) => {
			if (message.replaceAll("[", "").replaceAll("]", "") == "LB.GetEntries") {
			}
		},
	});

	return (
		<Grid2
			container
			justifyContent="center"
			alignItems="center"
			component={Paper}
			size={{ md: 12 }}
			spacing={1}
			p={1}
		>
			<Grid2 maxWidth={"fit-content"} justifyContent="center">
				<ShiftDayNavigatorControl preventInit withPaper={false} />
			</Grid2>
			<Grid2 size={{ md: 4.5, xs: 12 }}>
				<TextField
					label="Search"
					value={quickFilter}
					onChange={(
						event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
					) => {
						onQuickFilterChange(event?.target.value);
					}}
					size="small"
					fullWidth
					slotProps={{
						input: {
							startAdornment: (
								<InputAdornment position="start">
									<SearchIcon
										fontSize="small"
										sx={{ color: "action.active" }}
									/>
								</InputAdornment>
							),
						} as any,
					}}
				/>
			</Grid2>
			<Grid2 size={{ xs: 12 }}>
				<SectionMultiSelect
					value={selectedSections}
					onChange={onSectionsChange}
					label="Sections"
				/>
			</Grid2>
		</Grid2>
	);
};
